import React from 'react';
import FlatButton from 'material-ui/FlatButton';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';


//this is the practice component for Translational Motion Formulas.
//the questions are put in buttons.
//when user clicks bttn, the answer shows below as an image.

class OpticsPractice extends React.Component{

  handleUserInput1(){
    this.setState({slideIndex: 0});
  }

  handleUserInput2(){
    this.setState({slideIndex: 1});
  }

  handleUserInput3(){
    this.setState({slideIndex: 2});
  }

  handleUserInput4(){
    this.setState({slideIndex: 3});
  }

  handleUserInput5(){
    this.setState({slideIndex: 4});
  }

  handleUserInput6(){
    this.setState({slideIndex: 5});
  }

  handleUserInput7(){
    this.setState({slideIndex: 6});
  }

  handleUserInput8(){
    this.setState({slideIndex: 7});
  }


  constructor(props) {
    super(props);
    this.state = {
      slideIndex: null,
    };

    this.handleUserInput1 = this.handleUserInput1.bind(this);
    this.handleUserInput2 = this.handleUserInput2.bind(this);
    this.handleUserInput3 = this.handleUserInput3.bind(this);
    this.handleUserInput4 = this.handleUserInput4.bind(this);
    this.handleUserInput5 = this.handleUserInput5.bind(this);
    this.handleUserInput6 = this.handleUserInput6.bind(this);
    this.handleUserInput7 = this.handleUserInput7.bind(this);
    this.handleUserInput8 = this.handleUserInput8.bind(this);

  }

  render(){

    //imgsrc contains the answers
    const imgsrc = [<img src = {require ("./Formulas/1.png")} />, <img src = {require ("./Formulas/2.png")} />, <img src = {require ("./Formulas/3.png")} />,
     <img src = {require ("./Formulas/4.png")} />, <img src = {require ("./Formulas/5.png")} />, <img src = {require ("./Formulas/6.png")} />,
    <img src = {require ("./Formulas/7.png")} />, <img src = {require ("./Formulas/8.png")} /> ];

    return(

      <MuiThemeProvider>

      <div>
         <FlatButton label="Optics" onClick = {this.handleUserInput1} /> <FlatButton label="Magnification" onClick = {this.handleUserInput2} />
         <FlatButton label="Index of Refraction" onClick = {this.handleUserInput3} /> <FlatButton label="Snell’s" onClick = {this.handleUserInput4} />
         <FlatButton label="Power" onClick = {this.handleUserInput5} />
         <FlatButton label="Multiple lens (focal length)" onClick = {this.handleUserInput6} /> <FlatButton label="Multiple lens (power)" onClick = {this.handleUserInput7} />
         <FlatButton label="Multiple lens (magnification)" onClick = {this.handleUserInput8} />
      </div>

      <div style = {{paddingLeft: 220, paddingTop: 40}}> {imgsrc[this.state.slideIndex]} </div>

      </MuiThemeProvider>

    );
  }

}

export default OpticsPractice;



// WEBPACK FOOTER //
// ./src/Physics/Optics/OpticsPractice.js